export default __webpack_public_path__ + "static/media/fail-payment.9e97967a.png";